import { AUTH } from '../constants';

export const initialState = {
  isAuthLoading: false,
  currentUser: null,
  isAccountInvalid: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case AUTH.SIGNIN.REQUEST:
      return {
        ...state,
        isAuthLoading: true,
      };
    case AUTH.SIGNIN.SUCCESS:
      return {
        ...state,
        isAuthLoading: false,
        currentUser: action.payload,
        isAccountInvalid: false,
      };
    case AUTH.SIGNIN.FAILURE:
      return {
        ...state,
        isAuthLoading: false,
        currentUser: null,
      };
    case AUTH.SIGNOUT:
      return {
        ...state,
        isAuthLoading: false,
        currentUser: null,
        isAccountInvalid: false,
      };
    case AUTH.GET_USER:
      return {
        ...state,
        isAuthLoading: true,
      };
    case AUTH.FAIL_AUTHENTICATE:
      return {
        ...state,
        isAuthLoading: false,
        currentUser: null,
      };
    case AUTH.SIGNIN.ACCOUNT_INVALID:
      return {
        ...state,
        isAuthLoading: false,
        currentUser: null,
        isAccountInvalid: true,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/auth.reducer.js